import S3 from 'aws-sdk/clients/s3';
import { v4 as uuidv4 } from 'uuid';

import { IFolderNode } from '../types/dataset';
import { isNil } from 'lodash-es';

export function makeBucketUrl(bucket: string, region?: string): string {
  // https://aws.amazon.com/blogs/aws/amazon-s3-path-deprecation-plan-the-rest-of-the-story/
  const awsHost = 's3.amazonaws.com';

  // If bucket name contains dots, use soon to be deprecated path style url
  if (bucket.indexOf('.') !== -1) {
    return `https://${awsHost}/${bucket}`;
  } else {
    // otherwise use virtual-hosted style url
    return `https://${bucket}.${awsHost}`;
  }
}

function prefixToName(prefix: string, divider: string): string {
  const chunks = prefix.split(divider);
  for (let i = 0; i < chunks.length; ++i) {
    const chunk = chunks[chunks.length - 1 - i];
    if (chunk.length > 0) {
      return chunk;
    }
  }
  return '';
}

function listObjectsToFolderNode(
  output: S3.ListObjectsV2Output,
  skipHidden: boolean
): IFolderNode {
  const node: IFolderNode = {
    id: uuidv4(),
    name: prefixToName(output.Prefix!, '/'),
    path: output.Prefix!,
    type: 'folder',
  };

  let folders: IFolderNode[] = (output.CommonPrefixes || []).map(
    ({ Prefix: childPrefix }) => {
      return {
        id: uuidv4(),
        name: prefixToName(childPrefix!, '/'),
        path: childPrefix!,
        type: 'folder',
      };
    }
  );

  let files: IFolderNode[] = (output.Contents || [])
    .filter(({ Key: childKey }) => childKey !== output.Prefix) // Remove redundant entry?
    .map(({ Key: childKey }) => {
      return {
        id: uuidv4(),
        name: prefixToName(childKey!, '/'),
        path: childKey!,
        type: 'file',
      };
    });

  if (skipHidden) {
    folders = folders.filter((node) => !node.name.startsWith('.'));
    files = files.filter((node) => !node.name.startsWith('.'));
  }

  node.children = [...folders, ...files];

  return node;
}

export function listS3Objects(
  region: string,
  bucket: string,
  prefix: string
): Promise<IFolderNode> {
  return new Promise((resolve, reject) => {
    const s3 = new S3();

    s3.makeUnauthenticatedRequest(
      'listObjectsV2',
      {
        Bucket: bucket,
        Prefix: prefix,
        Delimiter: '/',
      },
      (err, data: S3.ListObjectsV2Output) => {
        if (err) {
          reject(err);
          return;
        }

        resolve(listObjectsToFolderNode(data, true));
      }
    );
  });
}
